class Client {
  constructor(token) {
    this.token = token

    try {
      this.data = JSON.parse(atob(this.token.split('.')[1]))
    // eslint-disable-next-line no-empty
    } catch (e) {}

    if (this.data) {
      this.email = this.data.email
      this.firstName = this.data.given_name
      this.lastName = this.data.family_name
    }
  }
}
export default Client
